
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ILookupService, IProcess, LookupCriteria } from "@tylertech/tyler-api-types";

/**
 * ProcessLookupService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ProcessLookupService {
    constructor(private readonly $apiService: ApiService) { }
    
    Lookup(pCriteria: LookupCriteria): Promise<IProcess[]> {
        return this.$apiService.sendAuth("IProcessLookupService/Lookup", pCriteria);
    }
}
